<template>
    <div>
        <b-form @submit.prevent="submit">
            <template v-if="enableMode">
                <div class="text-grey font-weight-600 mb-2s">
                    {{ $t('auth.scan_barcode') }}
                </div>
                <div class="text-grey mb-4">
                    {{ $t('auth.scan_barcode_hint') }}
                </div>
                <div class="text-center mb-4">
                    <b-img
                        v-if="qrCode"
                        :src="qrCode"
                        class="
                            w-180-px
                            border-1 border-white-smoke-5
                            rounded-xl
                        "
                    ></b-img>
                </div>
                <div class="text-grey font-weight-600 mb-2s">
                    {{ $t('auth.enter_digit') }}
                </div>
                <div class="text-grey mb-4">
                    {{ $t('auth.enter_digit_hint') }}
                </div>
                <b-form-group class="mb-4">
                    <OtpInput
                        v-model="otpCode"
                        ref="otpInput"
                        @onComplete="autoSubmit"
                    ></OtpInput>
                </b-form-group>
                <div>
                    <b-button
                        type="submit"
                        block
                        variant="cinnabar"
                        size="lg"
                        :disabled="disableSubmitBtn"
                        class="
                            text-semi-xl text-white
                            font-weight-600
                            rounded-xxl
                        "
                    >
                        <template v-if="loading">
                            <i class="far fa-spinner fa-spin mr-2"></i>
                            {{ $t('button.loading_processing') }}
                        </template>
                        <template v-else>
                            {{
                                enableMode
                                    ? $t('button.enable')
                                    : $t('button.disable')
                            }}
                        </template>
                    </b-button>
                </div>
            </template>
            <div v-else class="text-center">
                <div class="mb-4">
                    <img
                        src="@/assets/images/auth/2-fa-enabled.svg"
                        alt="enabled"
                        class="w-100-px"
                    />
                </div>
                <div class="text-xl text-grey font-weight-600 mb-4">
                    {{ $t('auth.authentication_code') }}
                </div>
                <b-form-group class="mb-4">
                    <OtpInput
                        v-model="otpCode"
                        ref="otpInput"
                        @onComplete="autoSubmit"
                    ></OtpInput>
                </b-form-group>
                <div class="mb-4">
                    <b-button
                        type="submit"
                        block
                        variant="cinnabar"
                        size="lg"
                        :disabled="disableSubmitBtn"
                        class="
                            text-semi-xl text-white
                            font-weight-600
                            rounded-xxl
                        "
                    >
                        <template v-if="loading">
                            <i class="far fa-spinner fa-spin mr-2"></i>
                            {{ $t('button.loading_processing') }}
                        </template>
                        <template v-else>
                            {{
                                enableMode
                                    ? $t('button.enable')
                                    : $t('button.disable')
                            }}
                        </template>
                    </b-button>
                </div>
                <div class="text-md text-blue-haze">
                    {{ $t('auth.two_factor_authentication_hint') }}
                </div>
            </div>
        </b-form>
    </div>
</template>

<script>
import OtpInput from '@/components/utils/OtpInput/OtpInput.vue';
import { TWO_FACTOR_STATUSES } from '@/constants/auth';
import { OTP_COMPLETED_TIMEOUT } from '@/constants/config';
import { ERRORS } from '@/constants/error';
import errorMixin from '@/mixins/error';
import { disableTwoFA, verifyTwoFA } from '@/services/auth.service';

export default {
    name: 'VerifyTwoFAForm',
    mixins: [errorMixin],
    components: { OtpInput },
    props: {
        value: {
            type: String,
            required: true,
            default: '',
        },
        qrCode: {
            type: null,
            default: null,
        },
        enableMode: {
            type: Boolean,
            required: true,
            default: false,
        },
    },
    data() {
        return {
            TWO_FACTOR_STATUSES,
            loading: false,
        };
    },
    computed: {
        otpCode: {
            get() {
                return this.value;
            },
            set(value) {
                this.$emit('input', value);
            },
        },
        disableSubmitBtn() {
            return this.loading;
        },
    },
    methods: {
        submit() {
            if (!this.$refs.otpInput?.validate()) {
                return;
            }
            this.loading = true;
            const submitFunc = this.enableMode
                ? verifyTwoFA(this.otpCode)
                : disableTwoFA(this.otpCode);
            submitFunc
                .then(() => {
                    this.$emit('success');
                })
                .catch((e) => {
                    if (
                        e?.response?.data?.messageCode ===
                        ERRORS.INVALID_2FA_CODE
                    ) {
                        this.$refs.otpInput?.setError(
                            this.$t('message.invalid_2fa_code')
                        );
                        return;
                    }
                    this.handleThrowError(e);
                })
                .then(() => {
                    this.loading = false;
                });
        },
        autoSubmit() {
            setTimeout(() => {
                this.submit();
            }, OTP_COMPLETED_TIMEOUT);
        },
    },
};
</script>

<style scoped></style>
